import { useEffect, useState, useContext, useMemo } from 'react';

import { Popover } from 'antd';

import Colon from '@/components/Colon';
import { ProductItemContext } from '@/providers/productItem';
import { ProductListContext } from '@/providers/productList';
import useProductStore from '@/store/product';
import { buriedPoint } from '@/utils/buriedPoint';
import Utils from '@/utils/Utils';

export function PriceDiscount(props) {
  const {
    discountPriceMaxDiscount,
    isMultiDiscount,
    hidePriceAndStock,
    priceDiscount,
    isPlusDiscount,
    productVO,
    marketLabelVO,
  } = props;

  const discountPrice = Utils.priceRound(discountPriceMaxDiscount * 10, 2);
  const discountText = isMultiDiscount ? '折起' : '折';

  const content = (
    <div className="flex text-[12px] leading-[21px]">
      <ul className="pr-[5px] text-right text-[#ff7800]">
        <li>&nbsp;</li>
        {productVO?.productPriceList.map((productPrice, index) => (
          <li key={index}>
            {productPrice.spNumber * productVO.theRatio}+ <Colon />
          </li>
        ))}
      </ul>
      <ul className="pr-[14px] text-[#ff7800]">
        <li className="indent-[1em]">{isPlusDiscount ? 'PLUS价' : '折后价'}</li>
        {productVO?.productPriceList.map((_, index) => (
          <li key={index}>￥{Utils.priceRound(priceDiscount?.priceList[index]?.price || 0, 6)}</li>
        ))}
      </ul>
      <ul className="text-[#999]">
        <li className="indent-[1em] text-[#ff7800]">原价</li>
        {productVO?.productPriceList.map((productPrice, index) => (
          <li key={index}>
            {Utils.priceRound(productPrice?.thePrice, 6) ===
            Utils.priceRound(priceDiscount?.priceList[index]?.price || 0, 6) ? (
              <>&nbsp;</>
            ) : (
              <s>￥{Utils.priceRound(productPrice?.thePrice, 6)}</s>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="mb-[4px] text-center">
      {priceDiscount && !hidePriceAndStock && discountPrice !== 0 && discountPrice !== 10 && (
        <Popover
          placement="bottom"
          content={content}
          trigger="hover"
          zIndex={2}
          align={{
            offset: [0, 0],
          }}
        >
          <span className="mr-[4px] inline-block text-[12px] text-[#FF6201]">
            {discountPrice}
            {discountText}
          </span>
          <span className="mb-[3px] inline-block size-[7px] rotate-[225deg] border-l-[1px] border-t-[1px] border-solid border-[#FF6201]"></span>
        </Popover>
      )}
      {marketLabelVO?.is30MinPrice && <span className="ml-[6px] text-[#333]">近30天最低价</span>}
    </div>
  );
}

// 价格梯度
export function PriceLevel(props) {
  const { priceDiscount, isPlusDiscount, purchaseCount, onChange } = props;
  const { updateQuotedPriceData } = useProductStore();
  const { searchResult, track_zone } = useContext(ProductListContext);
  const { index, rs_log } = useContext(ProductItemContext);
  const { productVO } = props;

  async function quotedPrice() {
    buriedPoint({
      op: 'again',
      data: {
        pc: productVO?.productId,
        kw: searchResult?.globalSearchKeyword,
        cp: searchResult?.currePage,
        brand: productVO?.productGradePlateName,
        model: productVO?.productModel,
        code: productVO?.productCode,
        ix: index,
        rs_log,
      },
    });
    const lastIndex = productVO?.productPriceList?.length - 1;
    const numerousBargain = productVO?.productPriceList[lastIndex]?.epNumber + 1;
    updateQuotedPriceData({
      open: true,
      product: {
        productCode: productVO?.productCode,
        expectedPrice: productVO?.productPriceList[lastIndex]?.thePrice,
        specialNumber: numerousBargain * productVO?.theRatio,
        productStock: productVO?.validStockNumber * productVO?.theRatio,
        productStep: productVO?.theRatio,
        productUnit: productVO?.productUnit,
        productMinEncapsulationUnit: productVO?.productMinEncapsulationUnit,
        productMinEncapsulationNumber: productVO?.productMinEncapsulationNumber,
        track_zone: track_zone,
        key: new Date().getTime(),
      },
    });
  }

  const list = useMemo(() => {
    let newList = [];
    if (productVO?.productPriceList?.length > 0) {
      newList = productVO?.productPriceList.map((item, index) => {
        const spCount = item?.spNumber * productVO?.theRatio;
        const epCount = item?.epNumber * productVO?.theRatio;
        const count = Number(purchaseCount);
        let active = count >= spCount && count <= epCount;
        if (index + 1 === productVO?.productPriceList?.length) {
          active = count >= spCount;
        }
        let orderPrice = item?.thePrice;
        if (priceDiscount) {
          orderPrice = priceDiscount?.priceList[index]?.price;
          if (isPlusDiscount) {
            orderPrice = item?.thePrice;
          }
        }
        return {
          spCount,
          orderPrice,
          active,
          quotedPrice: false,
        };
      });
      if (productVO?.isShowQuotedPriceBtn) {
        const lastIndex = productVO?.productPriceList?.length - 1;
        const numerousBargain = productVO?.productPriceList[lastIndex]?.epNumber + 1;
        const count = numerousBargain * productVO?.theRatio;
        newList.push({
          spCount: count,
          active: false,
          quotedPrice: true,
        });
      }
    }
    return newList;
  }, [priceDiscount, isPlusDiscount, purchaseCount, productVO]);

  useEffect(() => {
    if (list?.length > 0) {
      const activeItem = list?.find((item) => item?.active);
      if (activeItem) {
        onChange(activeItem?.orderPrice);
      }
    }
  }, [list]);

  return (
    <ul className="w-[170px]">
      {list?.map((item, index) => {
        if (item?.quotedPrice) {
          return (
            <li className={`flex text-[#333]`} key="quotedPrice">
              <span className="w-[70px] text-right">
                {item?.spCount}+<Colon />
              </span>
              <button className="bg-transparent underline hover:text-[#1FA0E8]" onClick={quotedPrice}>
                报价
              </button>
            </li>
          );
        } else {
          return (
            <li
              className={`mb-[4px] flex last-of-type:mb-0 ${item?.active ? 'text-[#1FA0E8]' : 'text-[#333]'}`}
              key={index}
            >
              <label className="w-[70px] text-right">
                {item?.spCount}+<Colon />
              </label>
              <span className="flex-1 text-left">￥{Utils.priceRound(item?.orderPrice, 6)}</span>
            </li>
          );
        }
      })}
    </ul>
  );
}

export default function PriceLevelAndDiscount(props) {
  const { hidePriceAndStock, purchaseCount, onChange } = props;

  return (
    !hidePriceAndStock && (
      <>
        <PriceDiscount {...props}></PriceDiscount>
        <PriceLevel purchaseCount={purchaseCount} {...props} onChange={(value) => onChange(value)}></PriceLevel>
      </>
    )
  );
}

export function OldBatchPriceLevel(props) {
  const { productVO, purchaseCount, onChange } = props;

  const list = useMemo(() => {
    let newList = [];
    if (productVO?.productPriceList?.length > 0) {
      newList = productVO.productPriceList.map((item, index) => {
        const spCount = item?.spNumber * productVO?.theRatio;
        const epCount = item?.epNumber * productVO?.theRatio;
        const count = Number(purchaseCount);
        let active = count >= spCount && count <= epCount;
        if (index + 1 === productVO?.productPriceList?.length) {
          active = count >= spCount;
        }
        const orderPrice = item?.thePrice;
        return {
          spCount,
          orderPrice,
          active,
        };
      });
    }
    return newList;
  }, [productVO, purchaseCount]);

  useEffect(() => {
    if (list?.length > 0) {
      const activeItem = list?.find((item) => item?.active);
      if (activeItem) {
        onChange(activeItem?.orderPrice);
      }
    }
  }, [list]);

  return (
    <ul className="w-[170px]">
      {list?.map((item, index) => (
        <li
          className={`mb-[4px] flex last-of-type:mb-0 ${item?.active ? 'text-[#1FA0E8]' : 'text-[#444]'}`}
          key={index}
        >
          <span className="w-[70px] text-right">
            {item?.spCount}+<Colon />
          </span>
          <span className="flex-1 text-left">￥{Utils.priceRound(item?.orderPrice, 6)}</span>
        </li>
      ))}
    </ul>
  );
}

export function OverseasPriceLevel(props) {
  const { discountTieredPrices, tieredPrices, purchaseCount, onChange } = props;
  const [showMore, setShowMore] = useState(false);

  const list = useMemo(() => {
    let newList = [];
    if (tieredPrices?.length > 0) {
      newList = tieredPrices.map((item, index) => {
        const spCount = item?.countStart;
        const epCount = item?.countEnd;
        const count = Number(purchaseCount);
        let active = count >= spCount && count <= epCount;
        if (index + 1 === tieredPrices?.length) {
          active = count >= spCount;
        }
        let orderPrice = item?.price;
        if (discountTieredPrices) {
          orderPrice = discountTieredPrices?.[index].discountPrice;
        }
        return {
          spCount,
          orderPrice,
          active,
        };
      });
    }
    return newList;
  }, [discountTieredPrices, tieredPrices, purchaseCount, showMore]);

  useEffect(() => {
    if (list?.length > 0) {
      const activeItem = list?.find((item) => item?.active);
      if (activeItem) {
        onChange(activeItem?.orderPrice);
      }
    }
  }, [list]);

  return (
    <ul className="w-[170px]">
      {(showMore ? list : list.slice(0, 6))?.map((item, index) => (
        <li
          className={`mb-[4px] flex last-of-type:mb-0 ${item?.active ? 'text-[#1FA0E8]' : 'text-[#333]'}`}
          key={index}
        >
          <span className="w-[70px] text-right">
            {item?.spCount}+<Colon />
          </span>
          <span className="flex-1 text-left">￥{Utils.priceRound(item?.orderPrice, 6)}</span>
        </li>
      ))}
      {tieredPrices?.length > 6 && (
        <li className="cursor-pointer text-center" onClick={() => setShowMore(!showMore)}>
          {showMore ? (
            <span className="mb-[-2px] ml-[px] inline-block size-[7px] rotate-[45deg] border-l-[1px] border-t-[1px] border-solid border-[#444]"></span>
          ) : (
            <span className="mb-[3px] ml-[px] inline-block size-[7px] rotate-[225deg] border-l-[1px] border-t-[1px] border-solid border-[#444]"></span>
          )}
        </li>
      )}
    </ul>
  );
}

export function OverseaDiscount(props) {
  const { productDiscount, discountTieredPrices } = props;

  const content = (
    <div className="flex text-[12px] leading-[21px]">
      <ul className="pr-[5px] text-right text-[#ff7800]">
        <li>&nbsp;</li>
        {discountTieredPrices?.map((productPrice, index) => (
          <li key={index}>
            {productPrice.countStart}+<Colon />
          </li>
        ))}
      </ul>
      <ul className="pr-[5px] text-[#ff7800]">
        <li className="indent-[1em]">折后价</li>
        {discountTieredPrices?.map((productPrice, index) => (
          <li key={index}>￥{Utils.priceRound(productPrice?.discountPrice, 6)}</li>
        ))}
      </ul>
      <ul className="text-[#999]">
        <li className="indent-[1em] text-[#ff7800]">原价</li>
        {discountTieredPrices?.map((productPrice, index) => (
          <li key={index}>
            <s>￥{Utils.priceRound(productPrice?.price, 6)}</s>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="mb-[4px] text-center">
      {productDiscount && (
        <Popover
          placement="bottom"
          content={content}
          trigger="hover"
          zIndex={2}
          align={{
            offset: [0, 0],
          }}
        >
          <span className="mr-[9px] inline-block text-[12px] text-[#FF6201]">
            {Utils.priceRound(productDiscount * 10, 2)}折
          </span>
          <span className="mb-[3px] inline-block size-[7px] rotate-[225deg] border-l-[1px] border-t-[1px] border-solid border-[#FF6201]"></span>
        </Popover>
      )}
      <span className="ml-[6px] text-[#FF6201]">含税</span>
    </div>
  );
}
